<template>
    <div>
        <v-container>
            <v-text-field v-model="name" label="Annonsnamn" />
            <v-textarea v-model="code" label="Annonskod" />
            <v-checkbox v-model="status" label="Aktiva" />
            <v-btn @click="submit" :loading="load">Skicka in</v-btn>
            <v-btn @click="del" :loading="delload">Radera</v-btn>
        </v-container>
    </div>
</template>

<script>
import store from "../../../../store";
import axios from "axios";
export default {
    data: function() {
        return {
            id: this.$route.params.id,
            store: store,
            name: "",
            code: "",
            status: false,
            delload: false,
            load: false
        };
    },
    created: async function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        let resp = await axios.get(
            `${this.store.state.baseURL}adddetails/${this.id}`
        );
        let data = resp.data.ad[0];
        this.name = data.name;
        this.code = data.adcode;
        if (data.status == 0) this.status = false;
        else this.status = true;
    },
    methods: {
        del: async function() {
            this.delload = true;
            try {
                await axios(`${this.store.state.baseURL}deletead/${this.id}`);
                this.$router.replace("/admin/ads");
            } catch (err) {
                this.delload = false;
            }
            this.delload = false;
        },
        submit: async function() {
            this.load = true;
            let Formdata = new FormData();
            Formdata.set("id", this.id);
            Formdata.set("name", this.name);
            Formdata.set("code", this.code);

            var config = {
                url: `${this.store.state.baseURL}updatead`,
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: Formdata
            };

            try {
                await axios(config);
                this.$router.replace("/admin/ads");
            } catch (err) {
                console.log(err);
            }
            this.load = false;
        }
    }
};
</script>

<style></style>
